import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';

const Header = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: '/catalog', label: 'Catálogo', icon: AppsIcon },
  ];

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: '#161616',
        borderBottom: '1px solid #333',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ minHeight: '48px !important', gap: 3 }}>
          {/* Logo */}
          <Box
            component={Link}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              textDecoration: 'none',
              mr: 2,
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                background: 'linear-gradient(135deg, #0f62fe 0%, #4589ff 100%)',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <AppsIcon sx={{ fontSize: 14, color: 'white' }} />
            </Box>
            <Typography
              variant="subtitle2"
              sx={{ color: 'white', fontWeight: 600, letterSpacing: '0.02em' }}
            >
              Team I+D
            </Typography>
          </Box>

          {/* Navigation */}
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            {navItems.map(({ path, label, icon: Icon }) => (
              <Button
                key={path}
                component={Link}
                to={path}
                startIcon={<Icon sx={{ fontSize: '18px !important' }} />}
                sx={{
                  color: isActive(path) ? 'white' : 'rgba(255,255,255,0.7)',
                  fontSize: '0.8rem',
                  px: 1.5,
                  py: 0.75,
                  borderRadius: '6px',
                  backgroundColor: isActive(path) ? 'rgba(255,255,255,0.1)' : 'transparent',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    color: 'white',
                  },
                }}
              >
                {label}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          {/* Right side */}
          <Typography
            variant="caption"
            sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem' }}
          >
            IBM Colombia
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
